import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toElement as scrollToElement } from '@utils/scroll';
import './style.scss';

const SECTIONS = [
  { label: 'Landing',   selector: '.landing-page' },
  { label: 'About',     selector: '#about'         },
  { label: 'Technical', selector: '#experience'    },
  { label: 'Portfolio', selector: '#projects'      },
  { label: 'Contact',   selector: '#contact'       },
];

class SectionDots extends Component {
  scrollTo(selector) {
    scrollToElement(document.querySelector(selector));
  }

  render() {
    const { activeIndex } = this.props;
    const { colorPrimary } = this.context.theme;

    return (
      <div className="section-dots">
        {SECTIONS.map((section, i) => {
          const isActive = i === activeIndex;
          return (
            <button
              key={section.label}
              className={`section-dot${isActive ? ' section-dot--active' : ''}`}
              style={isActive ? { background: colorPrimary, boxShadow: `0 0 6px ${colorPrimary}` } : {}}
              onClick={() => this.scrollTo(section.selector)}
              aria-label={`Go to ${section.label}`}
            />
          );
        })}
      </div>
    );
  }
}

SectionDots.contextTypes = {
  theme: PropTypes.any,
};

SectionDots.defaultProps = {
  activeIndex: 0,
};

export default SectionDots;



// WEBPACK FOOTER //
// ./src/components/SectionDots/SectionDots.js